/*! Shared native-video caption attacher (LAG/LAC themes).
 *
 *  Why this exists: Shopify Files serve .vtt as application/octet-stream + nosniff, and a
 *  cross-origin <track> additionally needs the <video> to be crossorigin — so a track that
 *  points straight at a cdn.shopify.com .vtt silently yields zero cues (readyState 3). The fix:
 *  fetch the VTT ourselves (cdn.shopify.com sends Access-Control-Allow-Origin: *) and hand the
 *  track a SAME-ORIGIN text/vtt blob URL.
 *
 *  Every native-video surface in the theme must attach captions through this helper — never set
 *  track.src to a cdn.shopify.com URL directly.
 *
 *  API: window.LAGVideoCaptions.attach(videoEl, vttUrl)  — replaces any existing tracks; no-op on
 *  empty url. window.LAGVideoCaptions.objectUrl(url) -> Promise<blobUrl> if you need the raw blob.
 */
(function () {
  if (window.LAGVideoCaptions) return; // idempotent — safe to include from multiple sections

  var cache = {};

  function objectUrl(url) {
    if (cache[url]) return Promise.resolve(cache[url]);
    return fetch(url)
      .then(function (r) {
        if (!r.ok) throw new Error('VTT fetch failed: ' + r.status);
        return r.text();
      })
      .then(function (text) {
        cache[url] = URL.createObjectURL(new Blob([text], { type: 'text/vtt' }));
        return cache[url];
      });
  }

  function attach(videoEl, url) {
    if (!videoEl) return;
    videoEl.querySelectorAll('track').forEach(function (t) { t.remove(); });
    if (!url) return;
    objectUrl(url)
      .then(function (src) {
        var track = document.createElement('track');
        track.kind = 'captions';
        track.label = 'English';
        track.srclang = 'en';
        track.src = src;
        track.default = true;
        videoEl.appendChild(track);
        if (videoEl.textTracks && videoEl.textTracks.length) {
          videoEl.textTracks[0].mode = 'showing';
        }
      })
      .catch(function (e) { console.warn('Captions unavailable for this video:', e); });
  }

  window.LAGVideoCaptions = { attach: attach, objectUrl: objectUrl };
})();
